import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import { NavBarContainer } from 'common/NavBar';
import Layout from './index';

export default function SkeletonLayout() {
  return (
    <Layout>
      <Grid item xs={12} md={10} bgcolor="background.list">
        <NavBarContainer>
          <Skeleton variant="text" />
        </NavBarContainer>
      </Grid>
    </Layout>
  );
}
